import { render, staticRenderFns } from "./BGM.vue?vue&type=template&id=7c00ac38&scoped=true&"
import script from "./BGM.vue?vue&type=script&lang=js&"
export * from "./BGM.vue?vue&type=script&lang=js&"
import style0 from "./BGM.vue?vue&type=style&index=0&id=7c00ac38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c00ac38",
  null
  
)

export default component.exports